export default __webpack_public_path__ + "static/media/strong 6 strength.b233ee66.webp";